var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from "react";
import { classes } from "../../../utils/classes";
import Ring from "../../../components/Ring";
import Tooltip from "../../../components/Tooltip";
export default function Buttons(props) {
    var options = props.options, onClick = props.onClick, active = props.active;
    // Add onClick handlers to each, sort by primary/secondary (using current order as tiebreaker)
    var optionsWithOnClick = useMemo(function () {
        return options
            .map(function (option) { return (__assign(__assign({}, option), { onClick: function () { return onClick(active === option.key ? "" : option.key); }, active: active === option.key })); })
            .sort(function (a, b) {
            if (a.type === b.type)
                return 0;
            return a.type === "primary" ? -1 : 1;
        });
    }, [options, onClick, active]);
    return (_jsx("div", { className: "z-10 mt-12 flex flex-col gap-4", children: optionsWithOnClick.map(function (option, idx) { return (_jsx(Tooltip, { text: option.title, children: _jsxs("button", { onClick: option.onClick, className: classes("group/button relative flex cursor-pointer items-center justify-center rounded-lg bg-alveus-green p-2 shadow-sm transition-[filter] hover:brightness-125", option.type === "primary" ? "h-16 w-16" : "h-12 w-12", 
                // If the previous type is not the same, add a margin
                idx > 0 &&
                    optionsWithOnClick[idx - 1].type !== option.type &&
                    "mt-auto"), children: [_jsx(option.icon, { size: option.type === "primary" ? 48 : 32, className: "h-full w-full" }), _jsx(Ring, { active: option.active })] }) }, option.key)); }) }));
}
